"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Summary = void 0;
const react_1 = __importStar(require("react"));
const Collapse_1 = __importDefault(require("react-bootstrap/Collapse"));
const Table_1 = __importDefault(require("react-bootstrap/Table"));
require("./Summary.scss");
const SummaryAddonSection_1 = require("./SummaryAddonSection");
const SummaryResourceSection_1 = require("./SummaryResourceSection");
const SummaryTotalSection_1 = require("./SummaryTotalSection");
const Summary = (props) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const addonSections = [];
    const addonsByType = props.booking.getAddonsGroupedByType();
    for (let type in addonsByType) {
        const addons = addonsByType[type];
        addonSections.push(react_1.default.createElement(SummaryAddonSection_1.SummaryAddonSection, { key: type, title: type, addons: addons }));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Collapse_1.default, { in: isOpen },
            react_1.default.createElement("div", { className: "d-md-block" },
                react_1.default.createElement(Table_1.default, { borderless: true, size: "sm" },
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement(SummaryResourceSection_1.SummaryResourceSection, { booking: props.booking }),
                        addonSections)),
                react_1.default.createElement("hr", null))),
        react_1.default.createElement(Table_1.default, { borderless: true, size: "sm", className: "position-relative" },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement(SummaryTotalSection_1.SummaryTotalSection, { booking: props.booking, open: isOpen, onToggle: () => setIsOpen((prevOpen) => !prevOpen) })))));
};
exports.Summary = Summary;
